import React, { useContext, useEffect, useState } from 'react'
import Top from '../components/top'
import Table from '../components/table'
import { DetailsContext } from '../contexts/DetailsContext'
import { AuthContext } from '../contexts/AuthProvider'
import { useNavigate } from 'react-router-dom'

const Featured = () => {
    const {
        general,
        setGeneral,
        orders,
        setOrders,
        transactions,
        setTransactions,
        admins,
        setAdmins,
        services,
        setServices,
        forms,
        setForms,
        featured,
        setFeatured,
        payments,
        setPayments,
        sms,
        setSms,
        latestOrders,
        setLatestOrders,
        latestTransactions,
        setLatestTransactions,
        adminDetails,
        setAdminDetails
      } = useContext(DetailsContext)
      const {
        user,
        setUser,
        isLogged,
        setIsLogged,
        login,
        logout
      } = useContext(AuthContext)
      const inputs = [
        {
          name: "productID",
          icon: 'fa-solid fa-cube',
          type: 'text',
          placeholder: 'Enter Form Schema In JSON FORMAT'
        },
        {
          name: "status",
          icon: 'fa-solid fa-user',
          type: 'select',
          vals: [
            {
                name: 'Active',
                option: 'Active'
            },
            {
                name: 'Inactive',
                option: 'Inactive'
            },
          ]
        },
          
      ]
    const featColumns = ['ID', 'Service ID', 'Status']

    function addWallet(){
        window.location.replace('/edit')
    }
    const [showModal, setShowModal] = useState(false);
    const link = 'https://enky.xgramm.com/enky_backend/admins/featured.php'
    const navigate = useNavigate()
    useEffect(() => {
      if (!isLogged) {
        navigate('/')
      }
    }, [isLogged])
  return (
    <div style={{position: 'relative'}} className='w3-col l9 w3-right m9 s12 main'>
        <Top showModal={showModal} setShowModal={setShowModal} isAdd={true} value='Add New Featured' name='Feartured'/>
        <div className="w3-container">
        <Table tableName='featured' link={link} inputs={inputs} showModal={showModal} setShowModal={setShowModal} name='Featured Services' columns={featColumns} data={featured} summary={false} edit={true}/>
        </div>
    </div>
  )
}

export default Featured